import React from "react";
import {
  ClientHeading,
  HomeHeadingContainer,
  HomePageContainer,
  HomeSubText,
  LogoutButtonContainer,
} from "./style";
import { PagesCard } from "./PagesCard";
import { TenantLogoLoader } from "@components/TenantLogoLoader";
import { useUserInfo } from "@context/userInfo/userInfoContext";
import { LogoutButton } from "@components/layout/MenuItems";
import { Footer } from "@components/layout/Footer";

export const HomePage: React.FC = () => {
  const userInfo = useUserInfo();

  return (
    <HomePageContainer>
      <div style={{ marginTop: 64 }}>
        <TenantLogoLoader isHome />
      </div>
      <HomeHeadingContainer>
        <ClientHeading size="sm" color="gray" margin="md" noMargin>
          {userInfo.name}
        </ClientHeading>
        <HomeSubText size="md" color="gray" noMargin>
          Acesse uma das páginas abaixo para saber mais
        </HomeSubText>
      </HomeHeadingContainer>
      <PagesCard />
      <LogoutButtonContainer>
        <LogoutButton />
      </LogoutButtonContainer>
      <Footer />
    </HomePageContainer>
  );
};
